import { SupportingEvidenceProps } from '.';
import DocumentChunk from '../DocumentChunk';
import isPlural from '@/helpers/isPlural';
import { ThreadMessage } from '@/types';

interface ShowSupportingTextsProps {
  answerMessage: ThreadMessage;
  setShowAllChunks: SupportingEvidenceProps['setShowAllChunks'];
  showAllChunks: SupportingEvidenceProps['showAllChunks'];
}

const ShowSupportingTexts = ({ answerMessage, showAllChunks, setShowAllChunks }: ShowSupportingTextsProps) => {
  return (
    <div className="mb-2 text-xs">
      {answerMessage?.chunks.length > 0 && (
        <button
          className="mx-2 my-2 text-sm font-medium text-blue-600 hover:text-blue-800"
          onClick={() => setShowAllChunks(!showAllChunks)}
        >
          {showAllChunks
            ? 'Hide additional supporting texts'
            : `Show ${answerMessage?.chunks.length} supporting ${isPlural({
                one: 'text',
                more: 'texts',
                number: answerMessage?.chunks.length,
              })}...`}
        </button>
      )}
      {showAllChunks && (
        <div className="mt-2 flex flex-col gap-2">
          {answerMessage?.chunks.map((chunk) => (
            <div key={chunk.id} id={chunk.id}>
              <DocumentChunk chunk={chunk} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default ShowSupportingTexts;
